// import React, { useState } from 'react'
// import { useLocation, useNavigate } from 'react-router-dom'
// import { FaSearch, FaChevronRight, FaArrowLeft } from 'react-icons/fa'
// import Swal from 'sweetalert2'
// import axios from 'axios'
// import Navbar from './Navbar'
// import Concerts from '../Assets/Assests/concert 1.png'
// import HealthIcon from '../Assets/Assests/pajamas_doc-new.png'
// import { Spinner } from 'react-bootstrap'

// const MentalWellbeing = () => {
//   const navigate = useNavigate()
//   const location = useLocation()
//   const sections = location.state?.sections || []
//   const [visibleCount, setVisibleCount] = useState(6)
//   const [searchQuery, setSearchQuery] = useState('')

//   // const skillCategories = [
//   //   { icon: HealthIcon, title: 'Health Check-ups', category: 'health_checkup' },
//   //   { icon: Concerts, title: 'Concerts', category: 'concerts' },
//   // ]

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value)
//   }

//   const filteredSections = sections.filter((section) =>
//     section.sections.toLowerCase().includes(searchQuery.toLowerCase())
//   )

//   const handleBack = () => {
//     navigate(-1)
//   }

//   const handleViewMore = () => {
//     setVisibleCount(filteredSections.length)
//   }

//   const handleCardClick = async (section) => {
//     Swal.fire({
//       title: 'Processing...',
//       text: 'Please wait...',
//       allowOutsideClick: false,
//       didOpen: () => {
//         Swal.showLoading()
//       },
//     })

//     try {
//       const payload = { feature_id: section.id }
//       const response = await axios.post(
//         'https://aimuseumbackend.teslabird.com/feature/buy_feature/',
//         payload,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${localStorage.getItem('access')}`,
//           },
//         }
//       )

//       Swal.fire({
//         title: 'Success!',
//         text: response.data.msg,
//         icon: 'success',
//       }).then(() => {
//         const updatedSection = {
//           ...section, // Keeps `path` and other missing fields
//           ...response.data.data, // Updates the fields from API response
//         }

//         // console.log('Navigating with Data:', updatedSection)

//         navigate('/course', { state: { section: updatedSection } })
//       })
//     } catch (error) {
//       console.error('Error:', error)
//       Swal.fire({
//         title: 'Error!',
//         text: 'Failed to process request. Please try again.',
//         icon: 'error',
//       })
//     }
//   }

//   return (
//     <>
//       <Navbar />
//       <div className='container py-4'>
//         {/* Back Button */}
//         <button
//           className='btn btn-light d-flex align-items-center mb-4'
//           onClick={handleBack}
//         >
//           <FaArrowLeft className='me-2' /> Back
//         </button>

//         {/* Heading */}
//         <h1 className='fw-bold text-center w-100 mb-4'>Modules</h1>

//         {/* <div className='row d-flex flex-wrap mb-4'>
//           {skillCategories.map(({ icon, title, category }) => (
//             <CategoryCard
//               key={category}
//               icon={icon}
//               title={title}
//               category={category}
//               noApiCall
//             />
//           ))}
//         </div> */}

//         <div className='d-flex flex-wrap align-items-center mb-4 gap-3'>
//           {/* <div
//             className='w-100 mb-3'
//             style={{ borderTop: '1px solid #ccc' }}
//           ></div> */}
//           <div
//             className='position-relative ms-auto'
//             style={{ flex: '1 1 auto', minWidth: '250px', maxWidth: '400px' }}
//           >
//             <FaSearch
//               className='position-absolute text-muted'
//               style={{
//                 left: '15px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//               }}
//             />
//             <input
//               type='search'
//               placeholder='Search'
//               className='form-control ps-5 pe-5'
//               value={searchQuery}
//               onChange={handleSearchChange}
//               style={{ width: '100%', borderRadius: '50px', color: 'black' }}
//             />
//           </div>
//         </div>

//         <div className='row g-4'>
//           {filteredSections.slice(0, visibleCount).map((section) => (
//             <div
//               className='col-12 col-md-6 col-lg-4'
//               key={section.id}
//               onClick={() => handleCardClick(section)}
//               style={{ cursor: 'pointer' }}
//             >
//               <div
//                 className='card h-100 overflow-hidden'
//                 style={{ backgroundColor: '#B02013' }}
//               >
//                 {section.purchase_status === 'purchased' && (
//                   <span
//                     className='position-absolute top-0 end-0 bg-success text-white px-2 py-1'
//                     style={{ borderRadius: '0 0 0 8px', fontSize: '12px' }}
//                   >
//                     Purchased
//                   </span>
//                 )}
//                 <img
//                   src={`https://testaiglobal.tdtlworld.com${section.path}`}
//                   alt={section.sections}
//                   className='card-img-top'
//                   style={{ height: '200px', objectFit: 'cover' }}
//                 />
//                 <div className='card-body d-flex flex-column'>
//                   <h5 className='card-title text-white fw-semibold'>
//                     {section.sections}
//                   </h5>
//                   <p className='text-white-50 mb-0'>Points: {section.points}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {visibleCount < filteredSections.length && (
//           <div className='mt-4 d-flex justify-content-end'>
//             <button
//               className='btn btn-link text-primary d-flex align-items-center'
//               onClick={handleViewMore}
//             >
//               View more <FaChevronRight className='ms-1' />
//             </button>
//           </div>
//         )}
//       </div>
//     </>
//   )
// }

// export default MentalWellbeing

// import { useState } from 'react'
// import { useLocation, useNavigate } from 'react-router-dom'
// import { FaSearch, FaChevronRight } from 'react-icons/fa'
// import Swal from 'sweetalert2'
// import axios from 'axios'
// import Navbar from './Navbar'

// const MentalWellbeing = () => {
//   const navigate = useNavigate()
//   const location = useLocation()
//   const sections = location.state?.sections || []
//   console.log('Sections:', sections)
//   const [visibleCount, setVisibleCount] = useState(6)
//   const [searchQuery, setSearchQuery] = useState('')

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value)
//   }

//   const filteredSections = sections.filter((section) =>
//     (section.module ?? '').toLowerCase().includes(searchQuery.toLowerCase())
//   )

//   const handleBack = () => {
//     navigate(-1)
//   }

//   const handleViewMore = () => {
//     setVisibleCount(filteredSections.length)
//   }

//   const handleCardClick = async (section, index) => {
//     Swal.fire({
//       title: 'Processing...',
//       text: 'Please wait...',
//       allowOutsideClick: false,
//       didOpen: () => {
//         Swal.showLoading()
//       },
//     })

//     try {
//       const response = await axios.get(
//         `https://aimuseumbackend.teslabird.com/membership/chapters/?module_id=${section.id}`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${localStorage.getItem('access')}`,
//           },
//         }
//       )

//       Swal.fire({
//         title: 'Success!',
//         text: response.data.msg,
//         icon: 'success',
//       }).then(() => {
//         const updatedSection = {
//           ...section,
//           ...response.data.data,
//           moduleNumber: index + 1, // Pass module number (1-based)
//         }

//         navigate('/course', { state: { section: updatedSection } })
//       })
//     } catch (error) {
//       console.error('Error:', error)
//       Swal.fire({
//         title: 'Error!',
//         text: 'Failed to process request. Please try again.',
//         icon: 'error',
//       })
//     }
//   }

//   return (
//     <>
//       <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//         <Navbar />
//         <div className='container bg-white'>
//           {/* Heading */}
//           <h1
//             className='fw-bold mt-4 mb-2'
//             style={{
//               fontSize: '2.5rem',
//               fontWeight: '500',
//               marginRight: '1rem',
//             }}
//           >
//             Modules
//           </h1>

//           {/* Search Bar */}
//           <div className='d-flex flex-wrap align-items-center mb-5 gap-3'>
//             <div
//               className='position-relative ms-auto'
//               style={{ flex: '1 1 auto', minWidth: '250px', maxWidth: '400px' }}
//             >
//               <FaSearch
//                 className='position-absolute text-muted'
//                 style={{
//                   left: '15px',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                 }}
//               />
//               <input
//                 type='search'
//                 placeholder='Search'
//                 className='form-control ps-5 pe-5'
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//                 style={{ width: '100%', borderRadius: '50px', color: 'black' }}
//               />
//             </div>
//           </div>

//           {/* Modules Grid */}
//           <div className='row g-4 mb-4'>
//             {filteredSections.map((section, index) => (
//               <div
//                 className='col-12 col-md-6 col-lg-4'
//                 key={section.id}
//                 onClick={() => handleCardClick(section, index)}
//                 style={{ cursor: 'pointer' }}
//               >
//                 {/* Default card (white background, black text) */}
//                 <div
//                   className='module-card default-card'
//                   style={{
//                     borderRadius: '8px',
//                     backgroundColor: 'white',
//                     padding: '10px',
//                     height: '100%',
//                   }}
//                 >
//                   <div className='card-body p-4'>
//                     {section.purchase_status === 'purchased' && (
//                       <span
//                         className='position-absolute top-0 end-0 bg-success text-white px-2 py-1'
//                         style={{
//                           borderRadius: '0 0 0 8px',
//                           fontSize: '12px',
//                         }}
//                       >
//                         Purchased
//                       </span>
//                     )}
//                     <div className='d-flex flex-column h-100'>
//                       {/* Module Number */}
//                       <h2 className='mb-2 fw-bold d-flex align-items-center'>
//                         {index + 1}
//                         <div className='green-line ms-2'></div>
//                       </h2>

//                       {/* Module Title */}
//                       <h5 className='card-title fw-bold mb-1'>
//                         {section.module}
//                       </h5>

//                       {/* Chapters Count */}
//                       {/* <p className='text-muted mb-3'>
//                         {section.chapters || Math.floor(Math.random() * 10) + 5}{' '}
//                         Chapters
//                       </p> */}
//                       <p className='text-muted mb-3'>
//                         {section.chapters} Chapters
//                       </p>

//                       {/* View Module Link */}
//                       <div className='mt-auto'>
//                         <a
//                           href='#'
//                           className='text-primary text-decoration-none'
//                           onClick={(e) => {
//                             e.preventDefault()
//                           }}
//                         >
//                           View Module
//                           <FaChevronRight
//                             className='ms-1'
//                             style={{ fontSize: '0.75rem' }}
//                           />
//                         </a>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Hover card (white background, blue text) */}
//                   <div className='module-card hover-card'>
//                     <div className='card-body p-4'>
//                       {section.purchase_status === 'purchased' && (
//                         <span
//                           className='position-absolute top-0 end-0 bg-success text-white px-2 py-1'
//                           style={{
//                             borderRadius: '0 0 0 8px',
//                             fontSize: '12px',
//                           }}
//                         >
//                           Purchased
//                         </span>
//                       )}
//                       <div className='d-flex flex-column h-100'>
//                         {/* Module Number */}
//                         <h2 className='mb-2 fw-bold d-flex align-items-center'>
//                           {index + 1}
//                           <div className='green-line ms-2'></div>
//                         </h2>

//                         {/* Module Title - Blue on hover */}
//                         <h5 className='card-title fw-bold mb-1 text-primary'>
//                           {section.module}
//                         </h5>

//                         {/* Chapters Count */}
//                         <p className='text-muted mb-3'>
//                           {section.chapters} Chapters
//                         </p>

//                         {/* View Module Link */}
//                         <div className='mt-auto'>
//                           <a
//                             href='#'
//                             className='text-primary text-decoration-none'
//                             onClick={(e) => {
//                               e.preventDefault()
//                             }}
//                           >
//                             View Module
//                             <FaChevronRight
//                               className='ms-1'
//                               style={{ fontSize: '0.75rem' }}
//                             />
//                           </a>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* {visibleCount < filteredSections.length && (
//             <div className='mt-4 d-flex justify-content-center'>
//               <button
//                 className='btn btn-outline-primary'
//                 onClick={handleViewMore}
//               >
//                 View More Modules <FaChevronRight className='ms-1' />
//               </button>
//             </div>
//           )} */}
//         </div>
//       </div>

//       {/* CSS for the cards */}
//       <style jsx>{`
//         .module-card {
//           background-color: white;
//           border-radius: 8px;
//           height: 100%;
//           /* transition: all 0.3s ease; */
//           position: relative;
//         }

//         .module-card:hover {
//           border-radius: 12px;
//           box-shadow: 0px 9px 4px 0px #00000040;
//         }

//         .default-card {
//           z-index: 2;
//           opacity: 1;
//         }

//         .hover-card {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           z-index: 3;
//           opacity: 0;
//           border-radius: 12px;
//           /* transition: all 0.3s ease; */
//           pointer-events: none;
//         }

//         .module-card:hover .hover-card {
//           opacity: 1;
//         }

//         .hover-card .card-title {
//           color: #1669c9;
//         }

//         .hover-card a {
//           text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
//           font-weight: 500;
//         }

//         .green-line {
//           height: 7px;
//           background-color: #69c969;
//           width: 100%;
//         }
//       `}</style>
//     </>
//   )
// }

// export default MentalWellbeing

import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import { FaSearch, FaChevronRight } from 'react-icons/fa'
import Navbar from './Navbar'

const MentalWellbeing = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const sections = location.state?.sections || []
  const [visibleCount, setVisibleCount] = useState(6)
  const [searchQuery, setSearchQuery] = useState('')

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const filteredSections = sections.filter((section) =>
    (section.module ?? '').toLowerCase().includes(searchQuery.toLowerCase())
  )

  const handleCardClick = async (section, index) => {
    Swal.fire({
      title: 'Processing...',
      text: 'Please wait...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    })

    try {
      const response = await axios.get(
        `https://aimuseumbackend.teslabird.com/membership/chapters/?module_id=${section.id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access')}`,
          },
        }
      )

      Swal.fire({
        title: 'Success!',
        text: response.data.msg,
        icon: 'success',
      }).then(() => {
        const updatedSection = {
          ...section,
          ...response.data.data,
          moduleNumber: index + 1,
        }
        navigate('/course', { state: { section: updatedSection } })
      })
    } catch (error) {
      console.error('Error:', error)
      Swal.fire(
        'Error!',
        'Failed to process request. Please try again.',
        'error'
      )
    }
  }

  return (
    <>
      <div className='mentalwellbeing-page'>
        <Navbar />
        <div className='container'>
          <h1 className='module-title'>Modules</h1>

          <div className='search-bar mb-5'>
            <div className='position-relative search-wrapper'>
              <FaSearch className='search-icon' />
              <input
                type='search'
                placeholder='Search'
                className='form-control search-input'
                value={searchQuery}
                onChange={handleSearchChange}
                style={{ color: 'black' }}
              />
            </div>
          </div>

          <div className='row g-4 mb-4'>
            {filteredSections.map((section, index) => (
              <div
                key={section.id}
                className='col-12 col-md-6 col-lg-4'
                onClick={() => handleCardClick(section, index)}
                style={{ cursor: 'pointer' }}
              >
                <div className='module-card'>
                  <div className='card-body p-4 d-flex flex-column h-100'>
                    <h2 className='mb-2 fw-bold d-flex align-items-center'>
                      {index + 1}
                      <div className='green-line ms-2'></div>
                    </h2>
                    <h5 className='card-title fw-bold mb-1'>
                      {section.module}
                    </h5>
                    <p className='text-muted mb-3'>
                      {section.chapters} Chapters
                    </p>
                    <div className='mt-auto'>
                      <a
                        href='#'
                        className='text-primary text-decoration-none'
                        onClick={(e) => e.preventDefault()}
                      >
                        View Module{' '}
                        <FaChevronRight
                          className='ms-1'
                          style={{ fontSize: '0.75rem' }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CSS */}
      <style jsx>{`
        .mentalwellbeing-page {
          background-color: white;
          min-height: 100vh;
        }

        .module-title {
          font-size: 2.5rem;
          font-weight: 500;
          margin-top: 1.5rem;
          margin-bottom: 1rem;
        }

        .search-wrapper {
          flex: 1 1 auto;
          min-width: 250px;
          max-width: 400px;
        }

        .search-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #6c757d;
        }

        .search-input {
          width: 100%;
          border-radius: 50px;
          padding-left: 2.5rem;
          color: black;
        }

        .module-card {
          position: relative;
          background-color: white;
          border-radius: 8px;
          height: 100%;
          transition: all 0.3s ease;
        }

        .module-card:hover {
          border-radius: 12px;
          box-shadow: 0px 9px 4px 0px #00000040;
        }

        .badge-purchased {
          position: absolute;
          top: 0;
          right: 0;
          background-color: #28a745;
          color: white;
          padding: 2px 8px;
          font-size: 12px;
          border-radius: 0 0 0 8px;
        }

        .green-line {
          height: 7px;
          background-color: #69c969;
          width: 100%;
        }
      `}</style>
    </>
  )
}

export default MentalWellbeing
